import { call, fork, put, takeEvery } from "redux-saga/effects";
import { API_AUDIT } from "../../helpers/api";
import * as actions from "../actions/operationHistory";
import { GET_OPERATION_HISTORY_LIST_REQUEST } from "../types";

// OPERATION HISTORY SAGA
function* watchGetOperationHistoryList() {
  yield takeEvery(GET_OPERATION_HISTORY_LIST_REQUEST, getOperationHistoryList);
}

function* getOperationHistoryList(action) {
  try {
    const res = yield call(apiGetOperationHistoryList, action.payload);
    yield put(
      actions.getOperationHistoryListSucceeded({
        items: [...res.data.items],
        activePage: res.data.currentPage,
        totalPageCount: Math.ceil(
          res.data.totalItemCount / action.payload.size
        ),
      })
    );
  } catch (err) {
    yield put(actions.getOperationHistoryListFailed());
  }
}

const apiGetOperationHistoryList = (reqParams) => {
  return API_AUDIT("audit/search", {
    ...reqParams,
  });
};

export default function* operationHistorySaga() {
  yield fork(watchGetOperationHistoryList);
}
